import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectToken } from '@reduxSlices/user/userSlices';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { isTokenExpired, refreshToken } from '@utils';
import { useDispatch } from 'react-redux';
import { setToken, selectUserData } from '@reduxSlices/user/userSlices';
import Login from '@pages/Login';
import Home from '@pages/Home';
import Company from '@pages/Company';
import Catalogs from '@/pages/Catalogs';
import Users from '@pages/Users';
import Receiving from '@/pages/Receiving';
import Layout from '@components/Layout';
import Products from '@/pages/Products';

const routes = [
  {
    path: `/receiving`,
    element: <Home />,
    exact: true,
  },
  {
    path: `/receiving/:id`,
    element: <Receiving />,
    exact: true,
  },
  {
    path: `/products`,
    element: <Products />,
    exact: true,
  },
  {
    path: `/company`,
    element: <Company />,
    exact: true,
    role: ['admin'],
  },
  {
    path: `/catalogs`,
    element: <Catalogs />,
    exact: true,
    role: ['admin', 'manager'],
  },
  {
    path: `/users`,
    element: <Users />,
    exact: true,
  },
];

const PrivateRoutes = ({ userData }) => {
  return (
    <Layout>
      <Routes>
        {routes
          .filter(({ role: roleRoute }) => (!roleRoute || roleRoute.includes(userData?.role) ? true : false))
          .map((route, key) => (
            <Route key={key} {...route} />
          ))}
        <Route path='/*' element={<Navigate replace to='/receiving' />} />
      </Routes>
    </Layout>
  );
};

const PublicRoutes = () => {
  return (
    <Routes>
      <Route path={`/login`} element={<Login />} exact />
      <Route path='/*' element={<Navigate replace to='/login' />} />
    </Routes>
  );
};

const RootRoutesComponent = () => {
  const { pathname } = useLocation();
  const token = useSelector(selectToken);
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();

  useEffect(() => {
    const refresh = async (token) => {
      const newToken = await refreshToken(token);
      if (newToken) {
        dispatch(setToken(newToken));
      } else {
        dispatch(setToken(null));
      }
    };

    if (token && isTokenExpired(token)) {
      refresh(token);
    }
  }, [pathname, token]);

  return token ? <PrivateRoutes userData={userData} /> : <PublicRoutes />;
};

export default RootRoutesComponent;
